export default __webpack_public_path__ + "static/media/MP_Skills_Situation_03.da6dc38a.png";